import React from "react";
import { ButtonProps } from "./types";
import { StyledButton } from "./styles";
import { Button as AntDButton } from "antd";
import ThemeColors from "../../themes/colors";

const Button: React.FC<ButtonProps> = ({
  backgroundColor = ThemeColors.Black900,
  textColor = ThemeColors.Bg300,
  borderRadius = "1.5rem",
  ...props
}): JSX.Element => {
  return (
    <StyledButton
      backgroundColor={backgroundColor}
      textColor={textColor}
      borderRadius={borderRadius}
    >
      <AntDButton {...props} />
    </StyledButton>
  );
};

export default Button;
